import Api from '@common/services/api';

export const deleteCategory = async (
  organisationId: string,
  categoryId: string
) => {
  await Api.delete(
    `/v1/organisations/${organisationId}/performance/competency/categories/${categoryId}`
  );
};
